import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-notify-export-data-customer-success-dialog',
  templateUrl: './notify-export-data-customer-success-dialog.component.html',
  styles: ['./notify-export-data-customer-success-dialog.component.scss']
})
export class NotifyExportDataCustomerSuccessComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<NotifyExportDataCustomerSuccessComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
  }

  ngOnInit() {

  }

  closeDialog() {
    this.dialogRef.close(false);
  }

}
